import React from "react";
import { Col } from "antd";

export const HalfWidthInputWrapper = ({ children, containerClass = '' }) => (
  <Col xs={24} lg={12} className={`step-form-main-container align-self-end ${containerClass}`}>
    {children}
  </Col>
);
